import { useState } from 'react'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify';

import { Container, Box } from '@material-ui/core'
import useRastreio from '../../hooks/useRastreio'
import Loading from '../../components/Loading/Loading'
import history from '../../services/history'
import pack from '../../assets/icon-pack.svg'
import { DateFormat, calculaDataDiasUteis } from "../../utils/DateFormat"
import {
    Date,
    DeliveryState,
    DeliveryStateContainer,
    DeliveryStateInfo,
    DeliveryStateWrapper,
    Icon,
    InfoContainer,
    Localization,
    LocalizationCity,
    Title,
} from '../../pages/layout/styles';

import truckImg from '../../assets/truck.svg'
import calendarImg from '../../assets/icon-calendar.svg'
import { Mapa } from "../../components/Mapa"
import { TransportadoraTipoId } from "../../utils/transportadora";
import { Redirect } from "../../components/Redirect/Redirect";

const RastreioConsulta = (props) => {
    const [animation, setAnimation] = useState(true);
    const { isLoading, rastreio } = useRastreio(props.match.params.codigoRastreio, history.location?.state)

    const deveRedirecionar = (
        !!rastreio && (
            (
                Number(rastreio.transportadoraTipo) === TransportadoraTipoId.TOTAL_EXPRESS &&
                rastreio.rastreios.length === 1
            ) ||
            ![
                TransportadoraTipoId.CORREIOS,
                TransportadoraTipoId.JT_EXPRESS,
                TransportadoraTipoId.TOTAL_EXPRESS
            ].includes(Number(rastreio.transportadoraTipo))
        )
    )

    if (deveRedirecionar) {
        return <Redirect url={rastreio?.rastreios.at(0).linkRastreio} />
    }

    if (isLoading || (!isLoading && !rastreio)) {
        return <Loading />;
    }

    if (!isLoading && rastreio && animation) {
        const element = document.getElementById('progress');
        element.classList.add('active');
        setTimeout(() => {
            element.classList.add('finish');
        }, 2000);

        setTimeout(() => {
            animationFinish();
        }, 4000);

        return <Loading />;
    }

    ReactGA.pageview('/RastreioConsulta');

    function animationFinish() {
        setAnimation(false);
    }

    function handleClickVoltar() {
        history.push('/');
    }

    function handleClickVisitarSiteTransportadora() {
        if (!rastreio.urlSiteTransportadora) return;
        window.open(rastreio.urlSiteTransportadora.toString(), '_blank')
    }

    const rastreioUnico = rastreio?.rastreios.at(0)

    const isSomenteUmVolumeRastreio = rastreio?.rastreios.length === 1
    const isNaoPossuiOcorrencias = rastreio?.ocorrencias.length === 0

    const isDeveMostrarCodigoRastreioLink = (
        !isNaoPossuiOcorrencias &&
        (
            isSomenteUmVolumeRastreio ||
            [
                TransportadoraTipoId.CORREIOS,
                TransportadoraTipoId.JT_EXPRESS
            ].includes(rastreio?.transportadoraTipo)
        )
    )

    function handleClickAcessarSite() {
        if (!isSomenteUmVolumeRastreio) {
            window.open(rastreioUnico.linkRastreio, '_blank');
            return;
        }

        const { codigoRastreio, linkRastreio } = rastreioUnico
        navigator.clipboard.writeText(codigoRastreio)
            .then(() => {
                toast.success("Código de Rastreio copiado para a área de transferência!");
                setTimeout(() => {
                    window.open(linkRastreio, '_blank')
                }, 1000)
            })
            .catch((error) => {
                toast.info(error)
            })
    }

    return (
        <Container className="container-frame">
            <Box className="header-frame">
                <button onClick={handleClickVoltar} className="header-action-button">
                    <span className="material-icons">&#xe5cb;</span>
                    Voltar
                </button>
                <Box className="frame-item-info frame-item-transportadora">
                    <Icon width="40px" height="40px" src={truckImg} />
                    <div className="txt-info">
                        <span className="txt-title">Transportadora</span>
                        <span className="txt-name" onClick={handleClickVisitarSiteTransportadora} style={{ cursor: rastreio.urlSiteTransportadora && "pointer" }}>{rastreio.transportadoraServico}</span>
                    </div>
                </Box>

                {
                    (isDeveMostrarCodigoRastreioLink) && (
                        <button onClick={handleClickAcessarSite} className="header-action-button acessar-site-transportadora">
                            Acessar site transportadora
                            <span className="material-icons">&#xe5cc;</span>
                        </button>
                    )
                }
            </Box>
            <Box className="content-frame" data-possui-mapa={!!rastreio.coordenadasUltimaOcorrencia}>
                {
                    isDeveMostrarCodigoRastreioLink && (
                        <header className="codigo-rastreio-transportadora">
                            Código rastreio transportadora: {rastreioUnico?.codigoRastreio}
                        </header>
                    )
                }
                {rastreio.prazo > 0 && (
                    rastreio.ocorrencias && rastreio.ocorrencias.length > 0
                        ? (
                            <span className="prazo-entrega">
                                Previsão de entrega <strong>{calculaDataDiasUteis(rastreio.prazo, rastreio.ocorrencias.at(-1)?.dataHora)}</strong>
                                {" "}({rastreio.prazo} {Number(rastreio.prazo) === 1 ? 'dia útil' : 'dias úteis'})
                            </span>
                        )
                        : (
                            <span className="prazo-entrega">Prazo para entrega <strong>{rastreio.prazo}</strong> dia(s)</span>
                        )
                )}
                {
                    isNaoPossuiOcorrencias
                        ? (
                            <Box className="empty-state-sem-ocorrencias">
                                <Icon width="120px" height="120px" src={pack} />
                                <h3>Sem ocorrências no momento :(</h3>
                                <p>Não se preocupe, você pode visitar o rastreio diretamente na transportadora clicando no botão abaixo.</p>
                                <button onClick={handleClickAcessarSite}>
                                    Rastrear Pedido
                                </button>
                            </Box>
                        )
                        : (
                            <>
                                {rastreio.coordenadasUltimaOcorrencia &&
                                    <Mapa
                                        latlong={rastreio.coordenadasUltimaOcorrencia}
                                        cidadePais={rastreio.ocorrencias.at(0)?.origem ?? ""}
                                    />
                                }
                                <Box className="frame-container-delivery-info" data-possui-mapa={!!rastreio.coordenadasUltimaOcorrencia}>
                                    {
                                        rastreio.ocorrencias.length > 0 && (
                                            <DeliveryStateWrapper className="delivery-info-ocorrencias">
                                                <h4>Histórico de ocorrências <sup>{rastreio.ocorrencias.length}</sup></h4>
                                                {rastreio.ocorrencias.map(ocorrencia => {
                                                    return (
                                                        <DeliveryState key={ocorrencia.situacao + ocorrencia.dataHora + ocorrencia.descricao.length}>
                                                            <DeliveryStateContainer className={!ocorrencia.origem ? 'centralizado' : undefined}>
                                                                <Icon width="40px" height="40px" src={truckImg} />

                                                                <InfoContainer>
                                                                    <Title
                                                                        title={String(ocorrencia.descricaoTransportadora ?? ocorrencia.descricao).toUpperCase()}
                                                                    >
                                                                        {ocorrencia.descricao}
                                                                        {
                                                                            (!ocorrencia.origem && !!ocorrencia.descricaoTransportadora) && (
                                                                                <small>
                                                                                    {ocorrencia.descricaoTransportadora}
                                                                                </small>
                                                                            )
                                                                        }
                                                                    </Title>
                                                                    {
                                                                        !!ocorrencia.origem && (
                                                                            <Localization>
                                                                                {ocorrencia.destino ? 'De:' : 'Em:'}
                                                                                <LocalizationCity title={ocorrencia.origem}>
                                                                                    {ocorrencia.origem}
                                                                                </LocalizationCity>
                                                                            </Localization>
                                                                        )
                                                                    }
                                                                </InfoContainer>

                                                                <InfoContainer type='min'>
                                                                    <Date>
                                                                        <Icon width="16px" height="16px" mr="10px" src={calendarImg} />
                                                                        {DateFormat(ocorrencia.dataHora)}
                                                                    </Date>

                                                                    <Localization>
                                                                        {ocorrencia.destino &&
                                                                            <>
                                                                                Para:
                                                                                <LocalizationCity
                                                                                    title={ocorrencia.destino}
                                                                                >
                                                                                    {ocorrencia.destino}
                                                                                </LocalizationCity>
                                                                            </>
                                                                        }
                                                                    </Localization>
                                                                </InfoContainer>
                                                            </DeliveryStateContainer>

                                                            {
                                                                (ocorrencia.detalhe || ocorrencia.endereco) && (
                                                                    <DeliveryStateInfo>
                                                                        {ocorrencia.detalhe && (
                                                                            <strong>{ocorrencia.detalhe}</strong>
                                                                        )}

                                                                        {ocorrencia.endereco && (
                                                                            <span>{ocorrencia.endereco}</span>
                                                                        )}
                                                                    </DeliveryStateInfo>
                                                                )
                                                            }
                                                        </DeliveryState>
                                                    )
                                                })}
                                            </DeliveryStateWrapper>

                                        )
                                    }
                                    {
                                        !isSomenteUmVolumeRastreio && rastreio.rastreios.length > 0 && (
                                            <DeliveryStateWrapper className="delivery-info-volumes">
                                                <h4>Volumes rastreáveis<sup>{rastreio.rastreios.length}</sup></h4>
                                                {rastreio.rastreios.map((volume, index) => (
                                                    <a
                                                        href={volume.linkRastreio}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        title={volume.codigoRastreio}
                                                        key={index}
                                                    >
                                                        <DeliveryState>
                                                            <DeliveryStateContainer>
                                                                <Icon width="40px" height="40px" src={pack} />

                                                                <div className="title">
                                                                    <span>Volume {index + 1}</span>
                                                                    <p>{volume.codigoRastreio}</p>
                                                                </div>

                                                                <div className="rastrear">
                                                                    Consultar
                                                                </div>
                                                            </DeliveryStateContainer>
                                                        </DeliveryState>
                                                    </a>
                                                ))}
                                            </DeliveryStateWrapper>
                                        )
                                    }
                                </Box>
                            </>
                        )
                }
            </Box>
            <p className="nome-loja">{rastreio.nomeLoja}</p>
        </Container>
    )
};

export default RastreioConsulta;